import request from '@/modules/base/util/request'
import settingsConfig from '@/modules/settings/config'

const baseUrl = settingsConfig.notification

export interface UpdateNotificationResponseData {
  notificateEmail: boolean,
  notificatePush: boolean,
  templateMeta: object
}
export interface GetSettingsResponseData {
  notificateEmail: boolean,
  notificatePush: boolean,
  templateMeta: object
}
export interface NotificationSettingData {
  email: boolean,
  push: boolean,
  webPush?: boolean,
}

// DO-13065: notification that carries the "verify your e-mail" CTA instead of a link
export const EMAIL_CONFIRMATION_NOTIFICATION_TYPE = 'EMAIL_CONFIRMATION'

export interface INotificationMetaData {
  type?: string
  [key: string]: unknown
}

export interface INotification {
  id: string
  readDate: string
  createdAt: string
  icon: string
  link: string | null
  text: string
  /** bold headline above `text`; older notifications don't have one */
  title?: string
  metaData?: INotificationMetaData
}

export const NotificationService = {
  getSettings: async(): Promise<GetSettingsResponseData> => {
    try {
      const response = await request(baseUrl, {
        method: 'GET',
        auth: true,
        isConcurrent: true,
      })

      return response.body.data
    } catch (error) {
      throw error
    }
  },
  updateSetting: async(name: string, { email, push, webPush }: NotificationSettingData): Promise<{ email: boolean, push: boolean, webPush: boolean }> => {
    try {
      const response = await request(baseUrl, {
        method: 'POST',
        auth: true,
        isConcurrent: true,
        data: { templateMeta: { [name]: { email, push, webPush } } },
      })

      return response.body.data.templateMeta[name]
    } catch (error) {
      throw error
    }
  },
}

export default NotificationService
